import React from 'react';
import Logo from '../../../assets/pdf logo.png';
import { dbToDate, dbToTime } from '../../../utils/dateTime';
import { formatCurrency } from '../../../utils/formatCurrency';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

const LIToPdf = ({ id, data }) => {
  const getCheckedKategoriInsiden = () => {
    const topCategory = data.listAllKategoriInsiden.filter(
      (dt) => dt.isCheked && dt.kategoriInsidenId < 4
    );
    const bottomCategory = data.listAllKategoriInsiden.filter(
      (dt) => dt.isCheked && dt.kategoriInsidenId > 3
    );
    return { topCategory, bottomCategory };
  };

  const getFilteredActualImpact = () => {
    const ai1 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 1
    );
    const ai2 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 2
    );
    const ai3 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 3 && dt.jumlahOrNilaiKerugian !== 0
    );
    const ai4 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 4
    );
    const ai5 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 5
    );
    const ai6 = data.listDetailActualImpactContent.filter(
      (dt) => dt.detailActualImpactId === 6
    );
    let totalLength = 1;
    if (ai1.length > 0) totalLength += ai1.length + 1;
    if (ai2.length > 0) totalLength += ai2.length + 1;
    if (ai3.length > 0) totalLength += ai3.length + 1;
    if (ai4.length > 0) totalLength += ai4.length + 1;
    if (ai5.length > 0) totalLength += ai5.length + 1;
    if (ai6.length > 0) totalLength += ai6.length + 1;
    return { ai1, ai2, ai3, ai4, ai5, ai6, totalLength };
  };

  return (
    <div id={id} style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>LAPORAN INVESTIGASI</h1>
        <img src={Logo} alt="pertamina" style={styles.logo} />
      </div>

      <table style={styles.table}>
        <tbody>
          <>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Kepada Yth :
              </td>
              <td style={styles.td} colSpan={11}>
                {data.listKepadas.map((item, idx) => (
                  <>
                    {item.seq}. {item.jabatanUser} <br></br>
                  </>
                ))}
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                No. Investigasi :
              </td>
              <td style={styles.td} colSpan={3}>
                {data.noLapInevest}
              </td>
              <td style={styles.td} colSpan={2}>
                Judul Laporan :
              </td>
              <td style={styles.td} colSpan={4}>
                {data.judulLaporan}
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Unit Bisnis :
              </td>
              <td style={styles.td} colSpan={3}>
                {
                  data.listUnitBisnis.find(
                    (obj) => obj.id === data.idUnitBisnis
                  ).name
                }
              </td>
              <td style={styles.td} colSpan={2}>
                Tgl. Kejadian :
              </td>
              <td style={styles.td} colSpan={4}>
                {dbToDate(data.tglKejadian)}
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Regional :
              </td>
              <td style={styles.td} colSpan={3}>
                {
                  data.listRegional.find((obj) => obj.id === data.idRegional)
                    .name
                }
              </td>
              <td style={styles.td} colSpan={2}>
                Waktu Kejadian :
              </td>
              <td style={styles.td} colSpan={4}>
                {dbToTime(data.waktuKejadian)} Local Time
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Lokasi :
              </td>
              <td style={styles.td} colSpan={3}>
                {data.listLokasi.find((obj) => obj.id === data.idLokasi).name}
              </td>
              <td style={styles.td} colSpan={2}>
                Tgl. Laporan :
              </td>
              <td style={styles.td} colSpan={4}>
                {dbToDate(data.tglLaporan)}
              </td>
            </tr>
          </>
          {/* INFORMASI KEJADIAN */}
          <>
            <tr style={styles.tr}>
              <td colSpan={14} style={styles.subtitle}>
                INFORMASI KEJADIAN
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Deskripsi Singkat Kejadian:
              </td>
              <td style={styles.td} colSpan={11}>
                <ReactMarkdown
                  children={data.deskripsiSingkat.replaceAll('\n', '<br />')}
                  rehypePlugins={[rehypeRaw]}
                />
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Titik Kejadian (maps) :
              </td>
              <td style={styles.td} colSpan={2}>
                {data.locationTagLat}, {data.locationTagLong}
              </td>
              <td style={styles.td} colSpan={2}>
                {data.namaLokasiOnMap || '-'}
              </td>
              <td style={styles.td} colSpan={2}>
                Perusahaan terlibat :
              </td>
              <td style={styles.td} colSpan={4}>
                {data.perusahaanTerlibat}
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Kategori Hipo :
              </td>
              <td style={styles.td} colSpan={3}>
                <input type="checkbox" disabled defaultChecked={data.isHipo} />{' '}
                HIPO
              </td>
              <td style={styles.td} colSpan={7}>
                <input type="checkbox" disabled defaultChecked={!data.isHipo} />{' '}
                NON - HIPO
              </td>
            </tr>
          </>
          {/* KATEGORI INSIDEN */}
          <>
            <tr style={styles.tr}>
              <td
                style={styles.td}
                colSpan={1}
                rowSpan={
                  3 +
                  getCheckedKategoriInsiden().topCategory.length +
                  getCheckedKategoriInsiden().bottomCategory.length
                }
              >
                Kategori Insiden
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={2}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().topCategory.find(
                    (dt) => dt.kategoriInsidenId === 1
                  )}
                />{' '}
                <b>Keselamatan dan Kesehatan Kerja</b>
              </td>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().topCategory.find(
                    (dt) => dt.kategoriInsidenId === 2
                  )}
                />{' '}
                <b>Kerusakan Properti</b>
              </td>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().topCategory.find(
                    (dt) => dt.kategoriInsidenId === 3
                  )}
                />{' '}
                <b>Keselamatan Proses</b>
              </td>
            </tr>
            {getCheckedKategoriInsiden().topCategory.map((item, idx) => (
              <tr key={idx} style={styles.tr}>
                <td style={styles.td} colSpan={2}>
                  {item.kategoriInsidenId === 1 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                <td style={styles.td} colSpan={3}>
                  {item.kategoriInsidenId === 2 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                <td style={styles.td} colSpan={3}>
                  {item.kategoriInsidenId === 3 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            ))}
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={2}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().bottomCategory.find(
                    (dt) => dt.kategoriInsidenId === 4
                  )}
                />{' '}
                <b>Kecelakaan Transportasi</b>
              </td>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().bottomCategory.find(
                    (dt) => dt.kategoriInsidenId === 5
                  )}
                />{' '}
                <b>Security</b>
              </td>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={getCheckedKategoriInsiden().bottomCategory.find(
                    (dt) => dt.kategoriInsidenId === 6
                  )}
                />{' '}
                <b>Lainnya</b>
              </td>
            </tr>
            {getCheckedKategoriInsiden().bottomCategory.map((item, idx) => (
              <tr key={idx} style={styles.tr}>
                <td style={styles.td} colSpan={2}>
                  {item.kategoriInsidenId === 4 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                <td style={styles.td} colSpan={3}>
                  {item.kategoriInsidenId === 5 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
                <td style={styles.td} colSpan={3}>
                  {item.kategoriInsidenId === 6 ? (
                    <>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailKategoriInsidenName}
                    </>
                  ) : (
                    <></>
                  )}
                </td>
              </tr>
            ))}
          </>
          {/* KRITERIA PENCATATAN INSIDEN */}
          <>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1} rowSpan={3}>
                Kriteria Pencatatan
              </td>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={data.isReportAble}
                />{' '}
                <b>Reportable</b>
              </td>

              <td style={styles.td} colSpan={5}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={!data.isReportAble}
                />{' '}
                <b>Non Reportable</b>
              </td>
            </tr>

            <tr style={styles.tr}>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={data.isWorkRelated}
                />{' '}
                <b>Work Related</b>
              </td>

              <td style={styles.td} colSpan={5}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={!data.isWorkRelated}
                />{' '}
                <b>Non Work Related</b>
              </td>
            </tr>

            <tr style={styles.tr}>
              <td style={styles.td} colSpan={3}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={data.isRecordAble}
                />{' '}
                <b>Recordable</b>
              </td>

              <td style={styles.td} colSpan={5}>
                <input
                  type="checkbox"
                  disabled
                  defaultChecked={!data.isRecordAble}
                />{' '}
                <b>Non Recordable</b>
              </td>
            </tr>
          </>
          {/* ACTUAL IMPACT */}
          <>
            <tr className="html2pdf__page-break"></tr>
            <tr style={styles.tr}>
              <td colSpan={13} style={styles.subtitle}>
                ACTUAL IMPACT
              </td>
            </tr>
            <tr style={styles.tr}>
              <td
                style={styles.td}
                colSpan={1}
                rowSpan={getFilteredActualImpact().totalLength}
              >
                Actual Impact
              </td>
            </tr>
            {/* HEALTH AND SAFETY */}
            {getFilteredActualImpact().ai1.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai1.length + 1}
                  >
                    <input type="checkbox" disabled defaultChecked /> Health And
                    Safety
                  </td>
                  <td colSpan={2} style={styles.td}>
                    Kategori
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Jumlah
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Satuan
                  </td>
                  <td colSpan={2} style={styles.td}>
                    Type Pekerja
                  </td>
                  <td colSpan={2} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai1.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={2} style={styles.td}>
                      <input
                        type="checkbox"
                        disabled
                        defaultChecked={item.jumlahOrNilaiKerugian !== 0}
                      />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {formatCurrency(item.jumlahOrNilaiKerugian)}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.satuan}
                    </td>
                    <td colSpan={2} style={styles.td}>
                      {item.tipePekerja === null ? '' : item.tipePekerja}
                    </td>
                    <td colSpan={2} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* ENVIRONMENT */}
            {getFilteredActualImpact().ai2.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai2.length + 1}
                  >
                    <input type="checkbox" disabled defaultChecked />{' '}
                    Environment
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Nama Produk
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Tipe
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Jumlah
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Satuan
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Nilai Konversi
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Hasil
                  </td>
                  <td colSpan={2} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai2.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={1} style={styles.td}>
                      <input
                        type="checkbox"
                        disabled
                        defaultChecked={item.jumlahOrNilaiKerugian !== 0}
                      />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.actualImpactContentItemName}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {formatCurrency(
                        parseFloat(item.jumlahOrNilaiKerugian).toFixed(2)
                      )}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.satuan}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {parseFloat(item.konversiSatuan).toFixed(2)}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {formatCurrency(item.nilaiKonversi)}
                    </td>
                    <td colSpan={2} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* FINANCIAL IMPACT */}
            {getFilteredActualImpact().ai3.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai3.length + 1}
                  >
                    <input type="checkbox" disabled defaultChecked /> Financial
                    Impact
                  </td>
                  <td colSpan={4} style={styles.td}>
                    Item
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Nilai Kerugian
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Satuan
                  </td>
                  <td colSpan={3} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai3.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={4} style={styles.td}>
                      <input
                        type="checkbox"
                        disabled
                        defaultChecked={item.jumlahOrNilaiKerugian !== 0}
                      />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.jumlahOrNilaiKerugian === 0
                        ? 0
                        : formatCurrency(
                            parseFloat(item.jumlahOrNilaiKerugian).toFixed(2)
                          )}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.satuan}
                    </td>
                    <td colSpan={3} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* REPUTATION IMPACT AND LEGAL */}
            {getFilteredActualImpact().ai4.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai4.length + 1}
                  >
                    Reputation Impact And Legal
                  </td>
                  <td colSpan={4} style={styles.td}>
                    Dampak Reputasi
                  </td>
                  <td colSpan={4} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai4.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={4} style={styles.td}>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={4} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* ASSET AND EQUIPMENT */}
            {getFilteredActualImpact().ai5.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai5.length + 1}
                  >
                    <input type="checkbox" disabled defaultChecked /> Asset And
                    Equipment
                  </td>

                  <td colSpan={4} style={styles.td}>
                    Tipe
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Nilai Kerugian
                  </td>
                  <td colSpan={1} style={styles.td}>
                    Satuan
                  </td>
                  <td colSpan={3} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai5.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={4} style={styles.td}>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {formatCurrency(
                        parseFloat(item.jumlahOrNilaiKerugian).toFixed(2)
                      )}
                    </td>
                    <td colSpan={1} style={styles.td}>
                      {item.satuan}
                    </td>
                    <td colSpan={3} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* PUBLIC NOTIFICATION */}
            {getFilteredActualImpact().ai6.length > 0 ? (
              <>
                <tr style={styles.tr}>
                  <td
                    style={styles.td}
                    colSpan={1}
                    rowSpan={getFilteredActualImpact().ai6.length + 1}
                  >
                    <input type="checkbox" disabled defaultChecked />
                    Public Notification
                  </td>

                  <td colSpan={4} style={styles.td}>
                    Public Notification
                  </td>
                  <td colSpan={4} style={styles.td}>
                    Keterangan
                  </td>
                </tr>
                {getFilteredActualImpact().ai6.map((item, idx) => (
                  <tr style={styles.tr} key={idx}>
                    <td colSpan={4} style={styles.td}>
                      <input type="checkbox" disabled defaultChecked />
                      {item.detailContentActualImpactName}
                    </td>
                    <td colSpan={4} style={styles.td}>
                      {item.keterangan === null ? '' : item.keterangan}
                    </td>
                  </tr>
                ))}
              </>
            ) : null}

            {/* SEVERITY */}
            <>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  Severity :
                </td>
                <td style={styles.td} colSpan={4}>
                  {data.potensiTingkatKeparahan}
                </td>
                <td style={styles.td} colSpan={1} rowSpan={1}>
                  Perlu Investigasi
                </td>
                {data.perluDilakukanInvestigasi ? (
                  <td style={styles.td} colSpan={3}>
                    <input
                      type="checkbox"
                      disabled
                      defaultChecked={data.perluDilakukanInvestigasi}
                    />{' '}
                    <b>Ya</b>
                  </td>
                ) : (
                  <td style={styles.td} colSpan={3}>
                    <input
                      type="checkbox"
                      disabled
                      defaultChecked={!data.perluDilakukanInvestigasi}
                    />{' '}
                    <b>Tidak</b>
                  </td>
                )}
              </tr>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  Probability :
                </td>
                <td style={styles.td} colSpan={4}>
                  {data.probabilitasKejadian}
                </td>
                <td style={styles.td} colSpan={1} rowSpan={1}>
                  Pelaksana Investigasi
                </td>
                <td style={styles.td} colSpan={5}>
                  {data.pelaksanaInvestigasi}
                </td>
              </tr>
              {data.tipeInsidenId === 3 ? (
                <tr style={styles.tr}>
                  <td style={styles.td} colSpan={1} rowSpan={1}>
                    Process Safety Event (PSE) Level
                  </td>
                  <td style={styles.td} colSpan={9}>
                    {
                      data.listPseLevel.find(
                        (dt) => dt.id === data.idMstPSELevel
                      ).name
                    }
                  </td>
                </tr>
              ) : null}
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={13}>
                  Keterangan *) Sesuai Pedoman Pengelolaan HSSE Berbasis Risiko
                </td>
              </tr>
            </>
          </>
          {/* DETAIL KLASIFIKASI KECELAKAAN */}
          {data.tipeInsidenId === 2 ? (
            <>
              <tr style={styles.tr}>
                <td colSpan={13} style={styles.subtitle}>
                  DETAIL KLASIFIKASI KECELAKAAN TRANSPORTASI
                </td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 1
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={3}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 1
                    )?.valueName
                  }
                </td>
                <td style={styles.td} colSpan={2}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 2
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={4}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 2
                    )?.valueName
                  }
                </td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 3
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={3}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 3
                    )?.valueName
                  }
                </td>
                <td style={styles.td} colSpan={2}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 4
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={4}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 4
                    )?.valueName
                  }
                </td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 5
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={3}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 5
                    )?.valueName
                  }
                </td>
                <td style={styles.td} colSpan={2}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 6
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={4}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 6
                    )?.valueName
                  }
                </td>
              </tr>
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={1}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 7
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={3}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 7
                    )?.valueName
                  }
                </td>
                <td style={styles.td} colSpan={2}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 8
                    )?.headerName
                  }{' '}
                  :
                </td>
                <td style={styles.td} colSpan={4}>
                  {
                    data.detailKlasifikasiKecelakaanTrans.find(
                      (o) => o.headerId === 8
                    )?.valueName
                  }
                </td>
              </tr>
            </>
          ) : null}
          {/* ANALISA PENYEBAB */}
          <>
            <tr style={styles.tr}>
              <td colSpan={13} style={styles.subtitle}>
                ANALISA PENYEBAB
              </td>
            </tr>
            {data.clsrCategoryName ? (
              <tr style={styles.tr}>
                <td style={styles.td} colSpan={2}>
                  Kategori CLSR :
                </td>
                <td style={styles.td} colSpan={10}>
                  {data.clsrCategoryName}
                </td>
              </tr>
            ) : null}
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={2}>
                Penyebab Langsung :
              </td>
              <td style={styles.td} colSpan={10}>
                <ReactMarkdown
                  children={data.penyebabLangsung.replaceAll('\n', '<br />')}
                  rehypePlugins={[rehypeRaw]}
                />
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={2}>
                Penyebab Dasar :
              </td>
              <td style={styles.td} colSpan={10}>
                <ReactMarkdown
                  children={data.penyebabDasar.replaceAll('\n', '<br />')}
                  rehypePlugins={[rehypeRaw]}
                />
              </td>
            </tr>
            {/*<tr style={styles.tr}>*/}
            {/*  <td style={styles.td} colSpan={2}>*/}
            {/*    Rekomendasi :*/}
            {/*  </td>*/}
            {/*  <td style={styles.td} colSpan={10}>*/}
            {/*    <ReactMarkdown*/}
            {/*      children={data.rekomendasi.replaceAll('\n', '<br />')}*/}
            {/*      rehypePlugins={[rehypeRaw]}*/}
            {/*    />*/}
            {/*  </td>*/}
            {/*</tr>*/}
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={2}>
                Rekomendasi :
              </td>
              <td style={styles.td} colSpan={10}>
                {data.listRekomendasi.length > 0 && (
                  <ReactMarkdown
                    children={data.listRekomendasi
                      .map((item) => `- ${item.rekomendasi}`)
                      .join('\n')}
                    rehypePlugins={[rehypeRaw]}
                  />
                )}
              </td>
            </tr>
          </>
          {/* TIM INVESTIGASI */}
          <>
            <tr style={styles.tr}>
              <td colSpan={13} style={styles.subtitle}>
                TIM INVESTIGASI
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={3}>
                <b>Nama Pegawai</b>
              </td>
              <td style={styles.td} colSpan={2}>
                <b>No. Pegawai</b>
              </td>
              <td style={styles.td} colSpan={2}>
                <b>Jabatan</b>
              </td>
              <td style={styles.td} colSpan={2}>
                <b>Jabatan Tim Investigasi</b>
              </td>
            </tr>
            {data.timInvestigasiList.map((item, idx) => (
              <tr style={styles.tr} key={idx}>
                <td style={styles.td} colSpan={3}>
                  {item.nama}
                </td>
                <td style={styles.td} colSpan={2}>
                  {item.nopek}
                </td>
                <td style={styles.td} colSpan={2}>
                  {item.jabatanUser}
                </td>
                <td style={styles.td} colSpan={2}>
                  {item.jabatanTim}
                </td>
              </tr>
            ))}
          </>
          {/* FOOTER */}
          <>
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={6} rowSpan={2}></td>
              <td style={styles.tdCenter} colSpan={7}>
                Dilaporkan Oleh:
              </td>
            </tr>

            <tr style={styles.tr}>
              <td style={styles.tdCenter} colSpan={7}>
                {data.userCreatorJabatan === null
                  ? ''
                  : data.userCreatorJabatan}
              </td>
            </tr>
            <tr style={styles.tr}>
              <td style={styles.tdBlank} colSpan={6}>
                {' '}
              </td>
              <td style={styles.tdBlank} colSpan={7}>
                {' '}
              </td>
            </tr>

            <tr style={styles.tr}>
              <td style={styles.td} colSpan={6}>
                {' '}
              </td>
              <td style={styles.tdCenter} colSpan={7}>
                {data.userCreator === null ? '' : data.userCreator}
              </td>
            </tr>

            <tr style={styles.tr}>
              <td style={styles.td} colSpan={6}>
                {' '}
              </td>
              <td style={styles.tdBottomLeft} colSpan={7}>
                {' '}
              </td>
            </tr>
            {/* ini dikasi if jika data.listTembusan != null dan data.listTembusan length > 0 baru dimunculkan */}
            <tr style={styles.tr}>
              <td style={styles.td} colSpan={1}>
                Tembusan :
              </td>
              <td style={styles.td} colSpan={11}>
                {data.listTembusan.map((item, idx) => (
                  <>
                    {item.seq}. {item.jabatanUser} <br></br>
                  </>
                ))}
              </td>
            </tr>
          </>
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  btnExport: {
    float: 'right',
  },
  page: {
    // backgroundColor: "lightgrey",
    // padding: "30px",
    marginTop: '-30px',
    paddingLeft: '30px',
    paddingRight: '30px',
    paddingBottom: '30px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: '120px',
    alignItems: 'center',
    marginBottom: '-30px',
  },
  title: {
    // marginLeft: "30px",
    fontSize: '28px',
    fontWeight: '600',
  },
  subtitle: {
    textAlign: 'center',
    fontWeight: '800',
    fontSize: '13px',
    border: '1px solid black',
    backgroundColor: 'lightGrey',
    // height: "35px",
  },
  logo: {
    height: '60px',
    width: 'auto',
  },
  table: {
    fontFamily: 'arial',
    borderCollapse: 'collapse',
    fontSize: '10px',
    width: '100%',
  },
  td: {
    border: '1px solid black',
    padding: '3.5px 10px',
  },
  tdBlank: {
    height: '150px',
    border: '1px solid black',
  },
  tdCenter: {
    textAlign: 'center',
    border: '1px solid black',
    padding: '3.5px 10px',
    fontWeight: '600',
  },
  tdBottomLeft: {
    textAlign: 'bottom',
    border: '1px solid black',
    padding: '3.5px 10px',
    fontWeight: '600',
  },
};

export default LIToPdf;
